import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { loadWatermarkSets } from '@/store/slices/watermarks';
import { selectProjectChannel } from '@/store/slices/project/selectors';

const useLoadChannelWatermarks = () => {
  const dispatch = useAppDispatch();
  const channel = useAppSelector(selectProjectChannel);

  useEffect(() => {
    if (channel) {
      dispatch(loadWatermarkSets({ channel }));
    }
  }, [channel, dispatch]);
};

export default useLoadChannelWatermarks;
